import { useCartAndDeliveryDatesDataContext } from '@app/data/clients/cartCheckoutClient';
import { useEffect, useState } from 'react';

export const useCartErrors = () => {
  const { errors } = useCartAndDeliveryDatesDataContext();

  const hasErrors = errors?.some((e) => e.severity === 'critical');

  const [hasCriticalError, setHasCriticalError] = useState<boolean>(false);
  useEffect(() => {
    if (hasErrors) {
      setHasCriticalError(true);
    }
  }, [hasErrors]);

  return [hasCriticalError, setHasCriticalError] as const;
};
